import { makeStyles } from '@material-ui/styles';
import CardMessageWrapper from '../CardMessageWrapper';

import { Text } from '@bizzabo/design-system';
import { Timestamp } from '@bizzabo/collaboration-common';
import { ExtendedGetStreamMessage } from '../UIMessage/types';

interface MissedCallMessageProps {
    icon?: JSX.Element;
    title?: string;
    text?: string;
    startTime?: ExtendedGetStreamMessage['created_at'];
}

const MissedCallMessage: React.FC<MissedCallMessageProps> = ({ icon, title, text, startTime }) => {
    const classes = useStyles();
    return (
        <CardMessageWrapper>
            <div className={classes.card}>
                <div className={classes.icon}>{icon}</div>
                <div className={classes.content}>
                    <Text variant="t70">{title}</Text>
                    <Text variant="t81">{text}</Text>
                    <Timestamp startTime={startTime} className={classes.timestamp} />
                </div>
            </div>
        </CardMessageWrapper>
    );
};

const useStyles = makeStyles(
    theme => ({
        card: {
            display: 'flex',
            color: theme.palette.greys[700],
        },
        icon: {
            marginRight: 20,
        },
        content: {
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
        },
        timestamp: {
            marginTop: 4,
        },
    }),
    { classNamePrefix: MissedCallMessage.name }
);

export default MissedCallMessage;
